export default __webpack_public_path__ + "static/media/faq-doc-white.4ec8e296.svg";